<script>
import api from "@services/api";
import Chamado from "@forms/Chamado";
import ChamadoComentario from "@components/ChamadoComentario";
import DateRangePicker from "vue2-daterange-picker";
import dateRangePickerConfig from "@configs/dateRangePickerConfig";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";

export default {
  name: "ChamadoDetalhe",
  page: {
    title: "Chamados"
  },
  components: {
    Chamado,
    ChamadoComentario,
    DateRangePicker
  },
  data: function() {
    return {
      chamadoList: [],
      showTimeLine: false,
      items: null,
      empty: true,
      page: 1,
      totalRows: 1,
      fields: [
        { name: "projeto", description: "Projeto" },
        { name: "assunto", description: "Assunto" },
        { name: "cliente", description: "Cliente" },
        { name: "etapaFluxoDenominacao", description: "Status" }
      ],
      size: 20,
      hasItems: false,
      sort: {
        sortBy: "id",
        sortOrder: "ASC"
      },
      showChamadoModal: false,
      chamadoFluxoList: [],
      chamadoId: undefined,
      editModeModalChamado: true,
      totalizador: null,
      showModalComentario: false,
      comentarioObrigatorio: false,
      postFluxo: false,
      etapaFluxoId: undefined,
      filtroDataInicio: undefined,
      filtroDataFim: undefined,
      filtroEtapaFluxo: undefined,
      filtroClienteId: undefined,
      customRanges: dateRangePickerConfig.customRanges,
      maxDate: dateRangePickerConfig.maxDate(),
      localeData: dateRangePickerConfig.localeData,
      dateRange: {
        startDate: new moment().subtract(60, "days"),
        endDate: new Date()
      },
      listaCliente: []
    };
  },
  watch: {
    page: function() {
      this.getChamadoList();
    },
    size: function() {
      this.getChamadoList();
    },
    sort: function() {
      this.getChamadoList();
    },
    filtroEtapaFluxo: function(val) {
      if (!(val == "Cancelado" || val == "Finalizado")) {
        this.dateRange.startDate = new moment().subtract(60, "days");
        this.dateRange.endDate = new moment();
      }
      this.getChamadoList();
    },
    "dateRange.startDate": function() {
      this.getChamadoList();
      this.getTotalizador();
    },
    "dateRange.endDate": function() {
      this.getChamadoList();
      this.getTotalizador();
    },
    filtroClienteId: function() {
      this.getChamadoList();
      this.getTotalizador();
    }
  },
  methods: {
    getChamadoList() {
      api
        .get(`api/Chamado/getChamado/${this.page}/${this.size}`, {
          params: {
            sortBy: this.sort.sortBy,
            sortOrder: this.sort.sortOrder,
            etapaFluxo: this.filtroEtapaFluxo,
            dataInicio: this.dateRange.startDate,
            dataFim: this.dateRange.endDate,
            clienteId: this.filtroClienteId
          }
        })
        .then(response => {
          this.items = response.data["data"];
          this.page = response.data["pagination"]["pageNumber"];
          this.totalRows = response.data["pagination"]["totalRecords"];
          this.hasItems = true;
        });
    },
    GetClientes() {
      api.get(`api/Chamado/GetClientes`).then(response => {
        this.listaCliente = response.data["data"];
        if (this.listaCliente.length == 1) {
          this.filtroClienteId = this.listaCliente[0].id;
        }
      });
    },
    editChamado(id) {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Chamado/Detalhes/${id}`,
          props: { editable: false }
        }
      );
    },
    callNew() {
      this.$helper.openModal();
      this.editModeModalChamado = false;
      this.showChamadoModal = true;
    },
    callDetails(id) {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/${this.table}/Detalhes/${id}`,
          props: {
            editable: false
          }
        }
      );
    },
    changeSort(field, sortable) {
      if (sortable == null) {
        sortable = true;
      }
      if (sortable) {
        if (field == this.sort.sortBy) {
          this.sort = {
            sortBy: field,
            sortOrder: this.sort.sortOrder == "ASC" ? "DESC" : "ASC"
          };
        } else {
          this.sort = {
            sortBy: field,
            sortOrder: "ASC"
          };
        }
      }
    },
    showSortDown(field, sortable) {
      if (sortable == null) {
        sortable = true;
      }
      if (!sortable) {
        return false;
      } else {
        return field == this.sort.sortBy && this.sort.sortOrder == "DESC"
          ? true
          : false;
      }
    },
    showSortUp(field, sortable) {
      if (sortable == null) {
        sortable = true;
      }
      if (!sortable) {
        return false;
      } else {
        return field == this.sort.sortBy && this.sort.sortOrder == "ASC"
          ? true
          : false;
      }
    },
    showSortNone(field, sortable) {
      if (sortable == null) {
        sortable = true;
      }
      if (!sortable) {
        return false;
      } else {
        return field == this.sort.sortBy ? false : true;
      }
    },
    getEtapasFluxo() {
      api.get(`api/Chamado/GetEtapasFluxoChamado`).then(response => {
        this.chamadoFluxoList = response.data["data"];
      });
    },
    listFluxo(id) {
      var perfilNaoCliente = this.user.perfil == "Cliente" ? false : true;
      var PerfilCliente = this.user.perfil == "Cliente" ? true : false;
      return this.chamadoFluxoList
        .filter(
          g =>
            g.etapaIdOrigem == id &&
            (PerfilCliente == g.comandadoCliente ||
              g.comandadoultor == perfilNaoCliente)
        )
        .map(c => ({
          denominacao: c.nomeAcao,
          id: c.id,
          etapaFluxoId: c.etapaIdDestino,
          comentario: c.comentarioObrigatorio
        }));
    },
    changeFluxo(EtapaFluxoId, chamadoId, comentario) {
      this.etapaFluxoId = EtapaFluxoId;
      this.chamadoId = chamadoId;

      if (!comentario) {
        let formData = new FormData();
        formData.append("ChamadoId", chamadoId);
        formData.append("EtapaFluxoId", EtapaFluxoId);
        api.post(`api/Chamado/ChangeEtapaFluxo`, formData).then(() => {
          this.getChamadoList();
          this.getTotalizador();
        });
      } else {
        this.postFluxo = true;
        this.comentarioObrigatorio = comentario;
        this.showComentario(chamadoId);
      }
    },
    closeModalChamado() {
      this.$helper.closeModal();
      this.showChamadoModal = false;
      this.getChamadoList();
      this.getTotalizador();
    },
    showComentario(id) {
      this.$helper.openModal();
      this.chamadoId = id;
      this.showModalComentario = true;
    },
    closeComentario(salvou, comentario, etapaFluxoId, fluxo) {
      this.$helper.closeModal();
      if (salvou && fluxo) {
        let formData = new FormData();
        formData.append("ChamadoId", this.chamadoId);
        formData.append("EtapaFluxoId", etapaFluxoId);
        api.post(`api/Chamado/ChangeEtapaFluxo`, formData).then(() => {
          this.getChamadoList();
          this.getTotalizador();
        });
      }
      this.showModalComentario = false;
      if (!salvou && comentario) {
        alert("as alterações não foram slavas");
      }
    },
    getTotalizador() {
      api
        .get(`api/Chamado/GetTotalizador`, {
          params: {
            clienteId: this.filtroClienteId,
            dataInicio: this.dateRange.startDate,
            dataFim: this.dateRange.dataFim
          }
        })
        .then(response => {
          this.totalizador = response.data["data"];
        });
    },
    filtrar(filtro) {
      if (filtro == this.filtroEtapaFluxo) {
        this.filtroEtapaFluxo = undefined;
      } else {
        this.filtroEtapaFluxo = filtro;
      }
    },
    padDigits(number, digits) {
      return (
        Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number
      );
    },
    selectRow(id) {
      this.editChamado(id);
    }
  },
  created() {
    this.filtroEtapaFluxo = "Iniciar";
    this.getChamadoList();
    this.getEtapasFluxo();
    this.getTotalizador();
    this.GetClientes();
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  }
};
</script>

<template>
  <div>
    <div class="row">
      <b-form-group
        id="input-group-2"
        label="Etapa:"
        label-for="dataRangeDataInicioDataFIm"
        class="ml-3"
      >
        <b-form-select id="EtapaFluxo" v-model="filtroEtapaFluxo">
          <b-form-select-option disabled :value="undefined"
            >Selecione um status da lista</b-form-select-option
          >
          <b-form-select-option value="Iniciar">
            A Iniciar
          </b-form-select-option>
          <b-form-select-option value="Andamento">
            Em Andamento
          </b-form-select-option>
          <b-form-select-option value="Impedimento">
            Com Impedimento
          </b-form-select-option>
          <b-form-select-option value="Finalizado">
            Finalizados
          </b-form-select-option>
          <b-form-select-option value="Cancelado">
            Cancelados
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
      <b-form-group
        id="input-group-2"
        label="Período"
        label-for="dataRangeDataInicioDataFIm"
        class="ml-3"
        v-if="
          filtroEtapaFluxo == 'Cancelado' || filtroEtapaFluxo == 'Finalizado'
        "
      >
        <date-range-picker
          ref="picker"
          :opens="'right'"
          :locale-data="localeData"
          :ranges="customRanges()"
          :showWeekNumbers="true"
          :autoApply="true"
          v-model="dateRange"
          :linkedCalendars="true"
        >
          <template v-slot:input="picker" style="width: 365px !important;">
            {{ picker.startDate | formatField("date") }} -
            {{ picker.endDate | formatField("date") }}
          </template>
        </date-range-picker>
      </b-form-group>
      <b-form-group
        id="input-group-2"
        label-for="dataRangeDataInicioDataFIm"
        label="Cliente:"
        class="ml-3"
      >
        <b-form-select id="EtapaFluxo" v-model="filtroClienteId">
          <b-form-select-option
            :value="undefined"
            v-if="user.perfil != 'Cliente'"
            >Todos</b-form-select-option
          >

          <b-form-select-option
            v-for="option in listaCliente"
            :key="option.id"
            :value="option.id"
          >
            {{ option.nome }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
    </div>
    <div class="text-center">
      <div class="row">
        <div class="col-md-2 col-xl-2" style="cursor: pointer">
          <div
            @click="filtrar('Iniciar')"
            :class="
              filtroEtapaFluxo == 'Iniciar'
                ? 'py-1 chamado-list-selected'
                : 'py-1'
            "
          >
            <h3 class="text-primary noselect">
              {{ totalizador ? totalizador.ainiciar : "N/D" }}
            </h3>
            <p class="text-uppercase mb-1 font-13 font-weight-medium noselect">
              A iniciar
            </p>
          </div>
        </div>
        <div class="col-md-2 col-xl-2" style="cursor: pointer">
          <div
            @click="filtrar('Andamento')"
            :class="
              filtroEtapaFluxo == 'Andamento'
                ? 'py-1 chamado-list-selected'
                : 'py-1'
            "
          >
            <h3 class="text-secondary noselect">
              {{ totalizador ? totalizador.emAndamento : "N/D" }}
            </h3>
            <p class="text-uppercase mb-1 font-13 font-weight-medium noselect">
              Em Andamento
            </p>
          </div>
        </div>
        <div class="col-md-2 col-xl-2" style="cursor: pointer">
          <div
            @click="filtrar('Impedimento')"
            :class="
              filtroEtapaFluxo == 'Impedimento'
                ? 'py-1 chamado-list-selected'
                : 'py-1'
            "
          >
            <h3 class="text-muted noselect">
              {{ totalizador ? totalizador.comImpedimento : "N/D" }}
            </h3>
            <p class="text-uppercase mb-1 font-13 font-weight-medium noselect">
              Com Impedimento
            </p>
          </div>
        </div>
        <div class="col-md-2 col-xl-2" style="cursor: pointer">
          <div
            @click="filtrar('Finalizado')"
            :class="
              filtroEtapaFluxo == 'Finalizado'
                ? 'py-1 chamado-list-selected'
                : 'py-1'
            "
          >
            <h3 class="text-warning noselect">
              {{ totalizador ? totalizador.finalizados : "N/D" }}
            </h3>
            <p class="text-uppercase mb-1 font-13 font-weight-medium noselect">
              Finalizados 60 dias
            </p>
          </div>
        </div>
        <div class="col-md-6 col-xl-2" style="cursor: pointer">
          <div
            class="py-1"
            @click="filtrar('Cancelado')"
            :style="
              filtroEtapaFluxo == 'Cancelado'
                ? 'background: rgba(0, 0, 200, 0.1)'
                : ''
            "
          >
            <h3 class="text-danger noselect">
              {{ totalizador ? totalizador.cancelados : "N/D" }}
            </h3>
            <p class="text-uppercase mb-1 font-13 font-weight-medium noselect">
              Cancelados
            </p>
          </div>
        </div>
        <div class="col-xl mt-3" style="text-align: right">
          <b-button class="btn" variant="primary" v-on:click="callNew()">
            Novo Chamado
          </b-button>
        </div>
      </div>
    </div>

    <div class="row mt-5 mb-2" v-show="!hasItems">
      <div class="col-md-12">Não foram encontrados registros.</div>
    </div>
    <div class="table-sm table mt-2" v-show="hasItems">
      <table class="table b-table table table-hover">
        <thead class="thead-primary">
          <tr>
            <th
              class="columnheader"
              scope="col"
              @click="changeSort('id', true)"
            >
              #
              <i
                class="fas fa-sort-down ml-2"
                v-show="showSortDown('id', true)"
              />
              <i class="fas fa-sort-up ml-2" v-show="showSortUp('id', true)" />
              <i
                class="fas fa-sort ml-2"
                style="color: lightgray"
                v-show="showSortNone('id', true)"
              />
            </th>
            <th class="columnheader" scope="col" style="width:100px;">
              Prioridade
            </th>
            <th class="columnheader" scope="col" style="width:40px;">
              Ordem
            </th>
            <th class="columnheader" scope="col" style="text-align:center">
              CH Prev
            </th>
            <th
              class="columnheader"
              scope="col"
              @click="changeSort(field.name, field.sortable)"
              v-for="field in fields"
              :key="field.name + '.' + field.type"
            >
              {{ field.description }}
              <i
                class="fas fa-sort-down ml-2"
                v-show="showSortDown(field.name, field.sortable)"
              />
              <i
                class="fas fa-sort-up ml-2"
                v-show="showSortUp(field.name, field.sortable)"
              />
              <i
                class="fas fa-sort ml-2"
                style="color: lightgray"
                v-show="showSortNone(field.name, field.sortable)"
              />
            </th>

            <th style="width:4%">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td scope="row" @click="selectRow(item.id)">
              {{ padDigits(item.numero, 4) }}
              <i
                class="fe-alert-circle mb-2"
                v-if="item.incidente"
                title="Incidente"
              >
              </i>
            </td>

            <td @click="selectRow(item.id)">
              <div data-toggle="tooltip" :title="item.toolTip">
                <span :class="`badge ${item.classeCss}`"
                  >{{ item.chamadoPrioridade }}
                </span>
              </div>
            </td>

            <td @click="selectRow(item.id)">
              <span> {{ item.ordem }} </span>
            </td>

            <td
              scope="row"
              style="text-align:center"
              @click="selectRow(item.id)"
            >
              {{ item.cargaHoraria }}h
            </td>

            <td
              v-for="field in fields"
              :key="field.name + '.' + field.type"
              @click="selectRow(item.id)"
            >
              {{ item[field.name] | formatField(field.type) }}
            </td>

            <td>
              <b-dropdown variant="light" text="..." size="sm">
                <b-dropdown-item @click="editChamado(item.id)"
                  >Visualizar</b-dropdown-item
                >
                <b-dropdown-item @click="showComentario(item.id)"
                  >Comentar</b-dropdown-item
                >
                <b-dropdown-item
                  @click="
                    changeFluxo(fluxo.etapaFluxoId, item.id, fluxo.comentario)
                  "
                  v-for="(fluxo, indexfluxo) in listFluxo(item.etapaFluxoId)"
                  :key="indexfluxo"
                >
                  {{ fluxo.denominacao }}
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row" v-show="totalRows > 10">
        <div class="col-md-9 mt-1">
          <b-pagination
            v-model="page"
            pills
            :total-rows="totalRows"
            :per-page="size"
          />
        </div>
        <div class="col-md-3">
          <b-form-group
            id="size"
            label-cols-lg="7"
            label="Registros por página:"
          >
            <b-form-select v-model="size">
              <b-form-select-option value="10">10</b-form-select-option>
              <b-form-select-option value="20">20</b-form-select-option>
              <b-form-select-option value="50">50</b-form-select-option>
              <b-form-select-option value="100">100</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>
      </div>
    </div>

    <b-modal
      id="chamadoModal"
      v-model="showChamadoModal"
      centered
      hide-footer
      title="Chamado"
      size="lg"
    >
      <Chamado
        :chamadoId="chamadoId"
        :editMode="editModeModalChamado"
        :closeModalChamado="closeModalChamado"
      />
    </b-modal>
    <b-modal
      id="chamadoComentarioModal"
      v-model="showModalComentario"
      centered
      hide-footer
      title="Adicionar comentário ao chamado"
      size="lg"
    >
      <ChamadoComentario
        :show="showModalComentario"
        :chamadoId="chamadoId"
        :closeModalChamado="closeComentario"
        :comentarioObrigatorio="comentarioObrigatorio"
        :changeFluxo="postFluxo"
        :etapaFluxoId="etapaFluxoId"
      />
    </b-modal>
  </div>
</template>

<style scoped>
.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
